import { useTemplateListContext } from '@/contexts/TemplatesContext';

import { Button } from '../ui/button';

const TemplateListTablePagination = () => {
  const { currentPage, itemsPerPage, setCurrentPage, templates, totalPages } =
    useTemplateListContext();

  const goToPage = (page) => {
    const totalPages = Math.ceil(templates.length / itemsPerPage);

    setCurrentPage(Math.max(1, Math.min(page, totalPages)));
  };

  return (
    <div className="flex items-center justify-between space-x-2 py-4 px-4">
      <div className="text-sm text-muted-foreground">
        Page {currentPage} of {totalPages} ({templates.length} templates)
      </div>
      <div className="flex items-center space-x-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => goToPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => goToPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default TemplateListTablePagination;
